import { Drfq } from './drfq/domain';
import { Grfq } from './grfq/domain';
import { BaseRfq, RfqType } from './shared';

export type Rfq = Grfq | Drfq;

export type RfqId = Rfq['id'];

export function getRfqTime(rfq: Rfq): number {
  switch (rfq.type) {
    case 'grfq':
      return rfq.latest_activity.getTime();
    case 'drfq':
      return rfq.last_updated_at.getTime();
    // no default
  }
}

export function getRfqCreatedAtDate(rfq: Rfq): Date {
  switch (rfq.type) {
    case 'grfq':
      return rfq.created;
    case 'drfq':
      return rfq.created_at;
    // no default
  }
}

export function getRfqTypeName(rfq: BaseRfq) {
  return getRfqTypeNameFromRfqType(rfq.type);
}

export function getRfqTypeNameFromRfqType(rfqType: RfqType) {
  switch (rfqType) {
    case 'drfq':
      return 'RFQ';
    case 'grfq':
      return 'OB';
    // no default
  }
}

export function isActiveRfq(rfq: Rfq) {
  switch (rfq.type) {
    case 'drfq':
      return rfq.state === 'OPEN' || rfq.state === 'RECENTLY_CLOSED';
    case 'grfq':
      return rfq.status === 'ACTIVE';
    // no default
  }
}

export const isGrfqId = (rfqId: RfqId): rfqId is Grfq['id'] =>
  typeof rfqId === 'number';

export const isDrfqId = (rfqId: RfqId): rfqId is Drfq['id'] =>
  typeof rfqId === 'string';
